import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC996SDxPhgHoswXZXMu8Drl92thrApZWY",
  authDomain: "ibhava.firebaseapp.com",
  projectId: "ibhava",
  storageBucket: "ibhava.firebasestorage.app",
  messagingSenderId: "347781823520",
  appId: "1:347781823520:web:58ac27c0ed0489b33c5045",
  measurementId: "G-0W88F84ZG6",
};

export const FirebaseApp = initializeApp(firebaseConfig);

if (window.location.hostname === "localhost") {
  var authFirebase = getAuth();
  connectAuthEmulator(authFirebase, "http://localhost:9099");
  var dbFirebase = getFirestore();
  connectFirestoreEmulator(dbFirebase, "localhost", 8080);
  var storageFirebase = getStorage();
  connectStorageEmulator(storageFirebase, "localhost", 9199);
  const functions = getFunctions(FirebaseApp);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
} else {
  authFirebase = getAuth(FirebaseApp);
  dbFirebase = getFirestore(FirebaseApp);
  storageFirebase = getStorage(FirebaseApp);
}

export const storage = storageFirebase;
export const auth = authFirebase;
export const db = dbFirebase;
export const googleProvider = new GoogleAuthProvider();
